<template>
  <n-config-provider :theme-overrides="themeOverrides" :locale="koKR" :date-locale="dateKoKR">
    <div v-if="this.$route.path !== '/dev'" :class="{ 'mobile-view': isMobileView }">
      <div
        v-show="this.$store.state.layout === 'landing'"
        class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
      />
      <LoadingSpinner v-if="this.$store.state.isLoading"/>

      <!-- 모바일 오버레이 배경 -->
      <div
        v-if="isMobileView && isMobileSidenavOpen"
        class="sidenav-overlay"
        @click="closeMobileSidenav"
      />

      <sidenav
        :custom_class="this.$store.state.mcolor"
        :class="[
          this.$store.state.isTransparent,
          'fixed-start',
          { 'sidenav-mobile-open': isMobileView && isMobileSidenavOpen },
          { 'sidenav-mobile-closed': isMobileView && !isMobileSidenavOpen }
        ]"
        v-if="this.$store.state.showSidenav"
      />
      <navbar
      :textWhite="
        this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
      "
      :minNav="navbarMinimize"
      />
      <main
        class="main-content position-relative h-100 border-radius-lg"
        :style="mainContentStyle"
      >
        <router-view />
      </main>
    </div>
    <div v-else>
      <router-view />
    </div>
    <!-- 2차 인증 step-up 창: API 가 MFA_REQUIRED·SEND_AUTH_REQUIRED 를 주면 뜬다 -->
    <step-up-modal />
    <!-- 로그인 뒤 6개월마다 운영자 계정 권한 확인(T-CONTRACT-1031 §2) -->
    <perm-review-modal />
  </n-config-provider>
</template>
<script>
import Sidenav from "@/views/components/Sidenav";
import Navbar from "@/views/components/Navbar.vue";
import LoadingSpinner from "@/views/components/Loading.vue";
import StepUpModal from "@/views/components/StepUpModal.vue";
import PermReviewModal from "@/views/components/PermReviewModal.vue";
import { mapMutations, mapState } from "vuex";
import { koKR, dateKoKR } from 'naive-ui';

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    LoadingSpinner,
    StepUpModal,
    PermReviewModal,
  },
  data() {
    return {
      mobileBreakpoint: 767,
    };
  },
  methods: {
    ...mapMutations(["navbarMinimize", "closeMobileSidenav", "setMobileView"]),
    checkMobileView() {
      const isMobile = window.innerWidth <= this.mobileBreakpoint;
      this.setMobileView(isMobile);
    },
    handleResize() {
      this.checkMobileView();
    },
  },
  mounted() {
    this.checkMobileView();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  setup() {
    const themeOverrides = {
      common: {
        primaryColor: '#8D939A',                                // 메인 색상
        primaryColorHover: '#278AEC',                           // 메인 색상의 hover 상태
        primaryColorPressed: '#2F3337',                         // 메인 색상의 pressed 상태
        primaryColorSuppl: '#FEE114',                           // 보조 메인 색상
        borderColor: '#8D939A',                                 // 테두리 색상
        fontFamily: 'SUIT-Regula, sans-serif',                  // 여기에 원하는 폰트 패밀리를 넣으세요.
        fontWeight: 600,
      }
    }

    return {
      themeOverrides,
      koKR, 
      dateKoKR,
    }
  },
  computed: {
    ...mapState(['isMobileView', 'isMobileSidenavOpen']),
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && !this.$store.state.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && this.$store.state.darkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4": !this.$store.state.isAbsolute,
      };
    },
    mainContentStyle() {
      const isAuthPage = this.$route.name === 'signIn' || this.$route.name === 'MobileTest';

      if (isAuthPage) {
        return 'padding-top: 75px; padding-left: 0 !important;';
      }

      if (this.isMobileView) {
        return 'padding-top: 75px; padding-left: 0 !important;';
      }

      return 'padding-top: 75px; padding-left: 15.625rem !important;';
    },
  },
  beforeMount() {

    if(localStorage.getItem("accessTokenCerti")) {
      this.$store.state.accessToken = localStorage.getItem("accessTokenCerti");
    }
    if(localStorage.getItem("refreshTokenCerti")) {
      this.$store.state.refreshToken = localStorage.getItem("refreshTokenCerti");
    }

    this.$store.state.isTransparent = "bg-transparent";
  },
};
</script>
<style>
/* Ant Design Vue 4.x 필수 필드 표시기(빨간 별표) 오버라이드 */
/* CSS-in-JS 이후에 로드되어야 하므로 App.vue에 위치 */
.ant-form-item-label > label.ant-form-item-required::before,
label.ant-form-item-required::before {
  display: inline-block !important;
  margin-inline-end: 4px !important;
  color: #ff4d4f !important;
  font-size: 14px !important;
  font-family: SimSun, sans-serif !important;
  line-height: 1 !important;
  content: '*' !important;
}

/* 모바일 사이드바 오버레이 */
.sidenav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  transition: opacity 0.3s ease;
}

/* 모바일에서 사이드바 숨김 (기본 상태) */
.sidenav-mobile-closed {
  transform: translateX(-100%) !important;
  transition: transform 0.3s ease !important;
}

/* 모바일에서 사이드바 열림 */
.sidenav-mobile-open {
  transform: translateX(0) !important;
  transition: transform 0.3s ease !important;
  z-index: 1000 !important;
}

/* 모바일 뷰 전체 스타일 */
.mobile-view .main-content {
  transition: padding-left 0.3s ease;
}

/* 모바일 사이드바 너비 확장 */
@media screen and (max-width: 767px) {
  .sidenav-mobile-open {
    width: 280px !important;
    max-width: 85vw !important;
  }

  .sidenav-mobile-open .navbar-nav .nav-link {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .sidenav-mobile-open .nav-link-text,
  .sidenav-mobile-open .sidenav-normal {
    white-space: normal !important;
    word-break: keep-all !important;
  }

  /* 사이드바 헤더 패딩 */
  .sidenav-mobile-open .sidenav-header {
    padding: 1rem !important;
  }

  /* 네비게이션 항목 간격 */
  .sidenav-mobile-open .navbar-nav > .nav-item {
    margin-bottom: 2px;
  }

  /* 서브메뉴 들여쓰기 */
  .sidenav-mobile-open .navbar-nav .nav .nav-link {
    padding-left: 2rem !important;
  }
}

/* 아주 작은 화면 (320px 이하) */
@media screen and (max-width: 320px) {
  .sidenav-mobile-open {
    width: 100vw !important;
    max-width: 100vw !important;
  }
}
</style>
